/* eslint-disable eag/match-named-export */
import {CountryResponseBody} from '@dms/api/shared';

import {Nullish} from 'shared/web';

import {IdentityCardData} from '../types/IdentityCardData';
import {IdentityCardType} from '../types/IdentityCardType';

export const getPersonIdentityCard = (
  identityCardData: IdentityCardData | Nullish,
  countries?: CountryResponseBody[],
  identityCardTypes?: IdentityCardType[]
) => {
  if (!identityCardData) {
    return '';
  }

  const country = countries?.find(
    (country) => country.code === identityCardData.issuedInCountryCode
  );

  const identityCardType = identityCardTypes?.find(
    (idType) => idType.code === identityCardData.type
  );

  return [
    identityCardType?.name || identityCardData.type,
    identityCardData.cardNumber,
    identityCardData.issuer,
    country?.name || identityCardData.issuedInCountryCode,
  ]
    .filter((x) => !!x)
    .join(', ');
};
